export function hasPermission(
  granted: readonly string[],
  required?: string,
): boolean {
  return !required || granted.includes(required)
}

export function hasEveryPermission(
  granted: readonly string[],
  required: readonly string[],
): boolean {
  return required.every((permission) => granted.includes(permission))
}
